import React from 'react'
import { Switch } from 'antd'

const stop = (e) => e.stopPropagation()

/**
 * Inline row with optional start/end content and an Ant Switch.
 */
const InlineSwitch = ({
  start,
  end,
  checked,
  onChange,
  disabled,
  size,
  switchProps,
  style,
  stopPropagation = false,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        ...style,
      }}
      onMouseDown={stopPropagation ? stop : undefined}
      onClick={stopPropagation ? stop : undefined}
    >
      {start}
      <Switch
        disabled={disabled}
        size={size}
        checked={checked}
        onChange={onChange}
        {...switchProps}
      />
      {end}
    </div>
  )
}

export default InlineSwitch

